export default {"src":"/_next/static/media/house_with_key_24.a9d0c807.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};